import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { AlertBoxComponent } from '../shared/alertbox.component';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { Respuesta } from './../entities/respuesta.entity';
import { Factura } from './../entities/factura.entity';
import { Contrato } from './../entities/contrato.entity';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { Explotacion } from '../entities/explotacion.entity';
import { MensajeDmService } from '../services/mensaje-dm.service';
import * as FileSaver from 'file-saver';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, AfterViewInit {
  public total: number;
  public consumo: number;
  public periodo: string;
  public periodocorto: string;
  public fechalectura: string;
  public efactura: boolean;
  public contratoSelected: Contrato;
  public contrato_num: number;
  public contratos: Contrato[];
  public facturas: Array<Factura>;
  public direccionSuministro: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public Facturaseleccionada: FacturaSeleccion = new FacturaSeleccion();
  public existenFacturas: Boolean;
  public telefonoexplotacion: string;
  public telefonoexplotacion2: string;
  public showENS: Boolean;
  public factText = 'factura';
  private dateFac: Date;
  private hoy: Date;
  private timerMensaje: any;
  
  private _opened = false;
  private _modeNum = 0;
  private _positionNum = 0;
  private _dock = false;
  private _closeOnClickOutside = false;
  private _closeOnClickBackdrop = false;
  private _showBackdrop = false;
  private _animate = true;
  private _trapFocus = true;
  private _autoFocus = true;
  private _keyClose = false;
  private _autoCollapseHeight: number = null;
  private _autoCollapseWidth: number = null;
  private _MODES: Array<string> = ['over', 'push', 'slide'];
  private _POSITIONS: Array<string> = ['left', 'right', 'top', 'bottom'];
  
  constructor(private userService: UserService, private sessionService: SessionService, private router: Router, private cdRef: ChangeDetectorRef, private mensajeDmService: MensajeDmService) { }
  
  ngOnInit() {
    if (this.sessionService.isAuthenticated) {
      const explotacion = this.sessionService.datosExplotacion;
      if (explotacion.Codigo.toUpperCase() === 'MELILLA') {
        this.factText = 'pre-factura';
      }
      if (explotacion.Estado === 'DM' && this.showMensajeDM(explotacion)) {
        this.mensajeDmService.setMensaje('AVISO', explotacion.EstadoDisManMensaje);
      }
      this.contratos = this.sessionService.contratos;
      this.showENS = this.sessionService.isShowedENS;
      if (this.sessionService.contratoSelected === undefined) {
        this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = 0;
      }
      if(this.sessionService.contratoSelected)
        this.cargarVariables(this.sessionService.contratoSelected);
    } else {
      this.router.navigate(['/']);
    }
  }
  
  public showMensajeDM(explotacion: Explotacion): boolean {
    const ahora = new Date();    
    const mensaje = explotacion.EstadoDisManMensaje;
    const inicioRaw = explotacion.EstadoDisManMenFechaInicio;
    const finRaw = explotacion.EstadoDisManMenFechaFin;
    if (!mensaje || mensaje.trim() === '') return false;
    if (!inicioRaw || !finRaw) return false;
    const inicio = new Date(inicioRaw);
    const fin = new Date(finRaw);
    if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return false;
    if (inicio > fin) return false;
    let mostrar = false;
    if (inicio.getTime() === fin.getTime() && this.mismaFecha(ahora, inicio)) {
      mostrar = true;
    } else {
      const inicioSinHora = inicio.getHours() === 0 && inicio.getMinutes() === 0 && inicio.getSeconds() === 0;
      const finSinHora = fin.getHours() === 0 && fin.getMinutes() === 0 && fin.getSeconds() === 0;
      if (inicioSinHora && finSinHora) { 
        const finExtendido = new Date(fin.getTime() + 24 * 60 * 60 * 1000);
        mostrar = ahora >= inicio && ahora < finExtendido;
      } else { 
        mostrar = ahora >= inicio && ahora <= fin;
      }
    }
    if (mostrar && fin > ahora && this.mismaFecha(ahora, fin)) {
      const tiempoRestante = fin.getTime() - ahora.getTime();
      clearTimeout(this.timerMensaje);
      this.timerMensaje = setTimeout(() => { this.mensajeDmService.ocultarMensaje(); }, tiempoRestante);
    }
    return mostrar;
  }
  
  private mismaFecha(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }
  
  ngAfterViewInit() {
    if (this.showENS) {
      this.showEnsMessage();
      this.sessionService.isShowedENS = false;
    }
  }
  
  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    if(contratoSelect) {
      this.cargarVariables(contratoSelect);
    }
  }
  
  public cargarVariables(contrato: Contrato): void {
    if (contrato.Facturas.length > 0) {
      this.existenFacturas = true;
      this.typeException = -1;
      this.total = contrato.Facturas[0].TotalFacturado;
      this.consumo = contrato.Facturas[0].ConsumoFactura;
      this.periodo = contrato.Facturas[0].Periodo.Descripcion;
      this.periodocorto = contrato.Facturas[0].PeriodoCodigo;
      this.fechalectura = contrato.Facturas[0].FechaLecturaLector.toString();
      this.Facturaseleccionada.version = contrato.Facturas[0].Version.toString();
      this.Facturaseleccionada.contratoVersion = contrato.Facturas[0].ContratoVersion.toString();
      this.facturas = contrato.Facturas;
      let facturasPendientes = 0;
      this.hoy = new Date();
      for (const fact of contrato.Facturas) {
        this.dateFac = new Date(fact.Fecha);
        this.dateFac.setDate(this.dateFac.getDate() + 30);
        if (fact.TotalCobrado < ((fact.TotalFacturado - 5)) && (this.dateFac > this.hoy)) {
          facturasPendientes = facturasPendientes + 1;
        }
      }
      facturasPendientes = 0;
      if (facturasPendientes > 0) {
        if (facturasPendientes === 1) {
          this.messageCabecera = 'Factura pendiente de cobro';
        } else {
          this.messageCabecera = 'Varias facturas pendiente de cobro';
        }
        this.typeException = 6;
      } else {
        this.messageCabecera = '';
        this.messageComplet = '';
        this.typeException = 10;
      }
    } else {
      this.existenFacturas = false;
      this.messageCabecera = 'Contrato sin facturas';
      this.messageComplet = 'El contrato seleccionado no tiene ninguna factura para mostrar';
      this.typeException = 0;
    }
    this.efactura = this.sessionService.efactura;
    this.direccionSuministro = contrato.InmuebleBO.Direccion;
    this.Facturaseleccionada.contratoCodigo = contrato.Codigo.toString();
    this.Facturaseleccionada.periodoCodigo = this.periodocorto;
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
    if (this.sessionService.datosExplotacion && this.sessionService.datosExplotacion.Contacto) {
      const TelsArray = this.sessionService.datosExplotacion.Contacto.split('-');
      this.telefonoexplotacion = TelsArray[0];
      this.telefonoexplotacion2 = TelsArray[1];
    }
  }
  
  public DescargarFactura() {
    this.userService.descargaFactura(this.Facturaseleccionada).subscribe(
      response => this.DescargaFacturaOnSuccess(response),
      error => this.DescargaFacturaOnError(error)
    );
  }
  
  public DescargaFacturaOnSuccess(response) {
    const fichero: Blob = response;
    const filename = 'factura_' + this.periodo + '.pdf';
    FileSaver.saveAs(fichero, filename);
  }
  
  public DescargaFacturaOnError(error) {
    let respError: Respuesta = error;
    console.log(respError.Ex.Message);
  }
  
  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;
    this.userService.updateuser(this.sessionService.explotacion, user).subscribe(
      response => this.updateuserOnSuccess(response),
      error => this.updateuserOnError(error)
    );
  }
  
  public updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
  }
  
  public updateuserOnError(error) {
    let respError: Respuesta = error;
    console.log(respError.Ex.Message);
  }
  
  public showEnsMessage() {
    this.messageCabecera = 'Aviso!';
    this.messageComplet = 'En cumplimiento de la normativa de seguridad de la entidad, le recordamos que debe aplicar la normativa de seguridad vigente, y en particular, hacer un uso adecuado de la información, proteger su confidencialidad, prevenir accesos no autorizados, custodiar de manera diligente sus credenciales e informar de manera inmediata a SACYR en caso de su pérdida';
    this.typeException = 0;
    AlertBoxComponent.changeMensaje.next(this.typeException);
    this.cdRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/home.component.ts